<template>
  <div class="px-4 py-5 space-y-4">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-lg font-extrabold text-slate-800 text-left">My Jobs</h1>
        <p class="text-xs text-slate-500 text-left">Jobs you posted</p>
      </div>
      <button type="button" class="px-3 py-1.5 rounded-lg bg-[#0d4169] text-white text-xs font-bold" @click="$router.push({ name: 'post_job' })">
        + Post
      </button>
    </div>

    <LoadingState :loading="loading" :message="!loading && !jobs.length ? 'You have not posted any jobs yet.' : ''">
      <button type="button" class="btn-primary mt-4" @click="$router.push({ name: 'post_job' })">Post Job</button>
    </LoadingState>

    <button
      v-for="job in jobs"
      :key="job.id"
      type="button"
      class="card-panel w-full p-4 text-left hover:bg-slate-50/80 transition"
      @click="$router.push({ name: 'job_detail', params: { id: job.id } })"
    >
      <div class="flex items-start justify-between gap-3">
        <div class="min-w-0">
          <h2 class="text-sm font-bold text-slate-800 truncate">{{ formatJobTitles(job.title) }}</h2>
          <p class="text-xs text-slate-500 mt-1">{{ formatJobMeta(job) }}</p>
        </div>
        <StatusBadge :status="getJobDisplayStatus(job)" />
      </div>
      <p v-if="job.status === 'published'" class="mt-2 text-[11px] text-[#0d4169] font-semibold">
        {{ job.applications_count }} application{{ job.applications_count === 1 ? '' : 's' }}
      </p>
    </button>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { apiFetch } from '../utils/api'
import { formatJobMeta, formatJobTitles, getJobDisplayStatus } from '../utils/jobFields'
import LoadingState from '../components/LoadingState.vue'
import StatusBadge from '../components/StatusBadge.vue'

export default {
  name: 'MyJobsView',
  components: { LoadingState, StatusBadge },
  setup() {
    const jobs = ref([])
    const loading = ref(true)

    async function load() {
      loading.value = true
      try {
        const res = await apiFetch('/jobs/mine')
        const data = await res.json()
        jobs.value = data.jobs || []
      } catch (err) {
        console.error(err)
      } finally {
        loading.value = false
      }
    }

    onMounted(load)
    return { jobs, loading, formatJobTitles, formatJobMeta, getJobDisplayStatus }
  },
}
</script>
